import React, { useState } from "react";
import "./BookDemoPage.css";
import BookDemoForm from "./components/BookDemoForm";
import ScheduleWalkthrough from "./components/ScheduleWalkthrough";
import Navbar from "../LandingPage/sections/Navbar";
import Footer from "../LandingPage/sections/Footer";
import { Check } from "lucide-react";

export default function BookDemoPage() {
  const isSchedulePath = typeof window !== "undefined" && window.location.pathname === "/schedule";
  const [submitted, setSubmitted] = useState(isSchedulePath);

  const bulletPoints = [
    "Understand how ThreatForge Sentry 2.0 AI finds what traditional security tools cannot.",
    "Discuss AI, MCP, agentic threat modeling, and secure-by-design priorities.",
    "Map the conversation directly to your current program maturity and software architecture.",
  ];

  return (
    <div className="tfl-book-demo-root bg-[#0b0f19] text-white min-h-screen flex flex-col font-sans">
      {/* Top Navbar */}
      <Navbar />

      {/* Main Content Area */}
      <main className="flex-1 pt-36 sm:pt-40 pb-16 px-6 sm:px-10 lg:px-12 max-w-7xl mx-auto w-full">
        {submitted ? (
          <ScheduleWalkthrough />
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 xl:gap-12 items-start">
            {/* Left Column: Information & Value Props */}
            <div className="lg:col-span-6 space-y-8 lg:pr-4">
              <div>
                <p className="tfl-demo-eyebrow">
                  Talk to an expert
                </p>

                <h1 className="tfl-demo-title">
                  See the future of agentic threat modeling.
                </h1>

                <p className="tfl-demo-subtitle">
                  Our security engineering team will be delighted to assist you! Fill out the form below to discuss your enterprise requirements and see how ThreatForge can protect your architecture.
                </p>
              </div>

              {/* Bullet Points */}
              <ul className="space-y-4 tfl-demo-bullets" role="list">
                {bulletPoints.map((point, index) => (
                  <li key={index} className="flex items-start gap-3.5">
                    <div className="w-6 h-6 rounded-full bg-purple-900/50 border border-purple-500/30 flex items-center justify-center shrink-0 mt-0.5">
                      <Check size={15} className="text-emerald-400" />
                    </div>
                    <span className="leading-snug">{point}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Right Column: Interactive Form */}
            <div className="lg:col-span-6 w-full">
              <BookDemoForm onSuccess={() => setSubmitted(true)} />
            </div>
          </div>
        )}
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}
